import { object } from "prop-types";

const CHANGE_CONTENT_INDEX="changeContentIndex";
const UPDATE_MANAGE_CLASS_LIST="updateManageClassList";
const UPDATE_EDIT_CLASS_INFO="updateEditClassInfo";
const UPDATE_CURRENT_SELECTED_CLASS_INFO="updateCurrentSelectedClassInfo";
const UPDATE_STUDENTS_LIST="updateStudentsList";
const UPDATE_CHANGE_CLASS_STUDENT_INFO="updateChangeClassStudentInfo";
const UPDATE_HOMEWORK_LIST="updateHomeworkList";
const UPDATE_CHANGED_HOMEWORK="updateChangedHomework";
const UPDATE_CHECK_HOMEWORK="checkHomework";
const UPDATE_CHECK_HOMEWORK_LIST="checkHomeworkList";
const UPDATE_CLASS_PROJECTS_LISt="updateClassProjectsList";
const initialState = {
    manageContentIndex:0,
    manageClassList:[],
    editClassInfo:'',               //被编辑的班级信息
    currentSelectedClassInfo:'',    //当前选中的班级信息
    studentsList:[],                //班级学生的数组
    changeClassStudentInfo:'',      //需要调换班级的学生信息
    homeworkList:[],                //作业列表,
    changedHomework:"",             //需要更改的学生作业
    checkHomework:"",                //查看作业时的学生作业
    checkHomeworkList:[],            //某个作业的全部作品
    classProjectsList:[]             //学生作品列表
}
const reducer = function(state = initialState, action) {
    let { type, params } = action;
    switch (type) {
        case CHANGE_CONTENT_INDEX: return Object.assign({}, state, {
            manageContentIndex: params
        });
        case UPDATE_MANAGE_CLASS_LIST:return Object.assign({},state,{
            manageClassList:params
        });
        case UPDATE_EDIT_CLASS_INFO:return Object.assign({},state,{
            editClassInfo:params
        });
        case UPDATE_CURRENT_SELECTED_CLASS_INFO:return Object.assign({},state,{
            currentSelectedClassInfo:params
        })
        case UPDATE_STUDENTS_LIST:return Object.assign({},state,{
            studentsList:params
        })
        case UPDATE_CHANGE_CLASS_STUDENT_INFO:return Object.assign({},state,{
            changeClassStudentInfo:params
        })
        case UPDATE_HOMEWORK_LIST:return Object.assign({},state,{
            homeworkList:params
        })
        case UPDATE_CHANGED_HOMEWORK:return Object.assign({},state,{
            changedHomework:params
        })
        case UPDATE_CHECK_HOMEWORK:return Object.assign({},state,{
            checkHomework:params
        })
        case UPDATE_CHECK_HOMEWORK_LIST:return Object.assign({},state,{
            checkHomeworkList:params
        })
        case UPDATE_CLASS_PROJECTS_LISt:return Object.assign({},state,{
            classProjectsList:params
        })
        default: return state;
    }
}

export {
    reducer as default,
    initialState as managerInitialState
}
